import React, { useEffect } from "react";
import { Card, Form, Input, InputNumber, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getJobApplicantDetails, doJobApplicantCreate, doJobApplicantUpdate 
} from "../../../../redux/jobapplicant/jobApplicantState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";


const JobApplicationForm = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	
  	const [form] = Form.useForm();
	const { recordId, mode } = props;

	useEffect(() => {
		if(recordId){
			getRecord(recordId);
		}
	}, [recordId, getRecord]);



  	return (
	<div>
		<Card className="flex flex-col gap-6 rounded-xl relative border-2 border-purple-100">
			<h2 className="text-gray-900 mb-6 text-lg font-medium">Personal Information</h2>
			
			<Form className="form"
				form={form} 
				layout="vertical"
				// onFinish={onSubmit}
			>   
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

				<FormItem
					name="first_name"
					label="First Name"
					rules={[requiredField()]}
				>
					{mode !== "view" ? (
					<Input
						id="first_name"
						className="input-field "
						placeholder="Enter first name"
						maxLength={100}
					/>
					) : (
					<label className="text-base label-value dark:text-white">
						{recordData?.first_name}
					</label>
					)}
				</FormItem>

				<FormItem
					name="last_name"
					label={
					<>
						Last Name 
					</>
					}
					rules={[requiredField()]}
				>
					{mode !== "view" ? (
					<Input
						id="last_name"
						className="input-field"
						placeholder="Enter last name"
						maxLength={100}
					/>
					) : (
					<label className="text-base label-value dark:text-white">
						{recordData?.last_name}
					</label>
					)}
				</FormItem>

				<FormItem
					name="email"
					label="Email"
					rules={[requiredField()]}
				>
					{mode !== "view" ? (
					<Input
						id="email"
						type="email"
						className="input-field"
						placeholder="Enter email address"
					/>
					) : (
					<label className="text-base label-value dark:text-white">
						{recordData?.email}
					</label>
					)}
				</FormItem>

				<FormItem
					name="phone"
					label="Phone Number" 
					rules={[requiredField()]}
				>
					{mode !== "view" ? (
					<Input
						id="phone"
						className="input-field"
						placeholder="Enter phone number"
					/>
					) : (
					<label className="text-base label-value dark:text-white">
						{recordData?.phone}
					</label>
					)}
				</FormItem>

				<FormItem
					className="md:col-span-2"
					name="linkedin_url"
					label="LinkedIn Profile URL (Optional)"
				>
					{mode !== "view" ? (
					<Input
						id="linkedin_url"
						className="input-field"
						placeholder="https://linkedin.com/in/yourprofile"
					/>
					) : (
					<label className="text-base label-value dark:text-white">
						{recordData?.linkedin_url}
					</label>
					)}
				</FormItem>

					{/* <div className="w-full flex justify-end">
						{(mode === "edit") && (
							<CrudButtons
								mode={mode}
								recordId={recordData?.jro_id ?? 0}
								isModal={true}
								modalId={recordData?.jro_id > 0 ? 'edit_job_role' : 'add_job_role'}
								cancelLabel="Cancel"
								doHideModal={onCancel}
								submitLabel={submitLabel}
								moduleId={MODULE_JOBROLES}
							/>
						)}
					</div> 				 			 */}
					</div>
				</Form>	 
			</Card>	
	</div>
	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.jobRole.jobRoleDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getJobApplicantDetails(id)),
  	doCreate: (data) => dispatch(doJobApplicantCreate(data)),
  	doUpdate: (data) => dispatch(doJobApplicantUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobApplicationForm);
